export enum RequestKey {
  GetEmailSender = "GetEmailSender",
  GetExpoPlatformSSOLink = "GetExpoPlatformSSOLink",
  GetExhibitorPair = "GetExhibitorPair",
  GetCountExhibitorPairByShow = "GetCountExhibitorPairByShow",
  GetOrganiserShowList = "GetOrganiserShowList",
  GetCompanyCustomFields = "GetCompanyCustomFields",
  GetExhibitorConnectionsByAdmin = "GetExhibitorConnectionsByAdmin",
  GetStandUsers = "GetStandUsers",
  GetAllExhibitorPairUsersByCurrentExhibitor = "GetAllExhibitorPairUsersByCurrentExhibitor",
  GetTaskTimeline = "GetTaskTimeline",
  GetTaskTimelineByType = "GetTaskTimelineByType",
  GetLastTaskTimelineAction = "GetLastTaskTimelineAction",
  GetTaskCommentsCount = "GetTaskCommentsCount",
  GetTaskCommentsAcknowledged = "GetTaskCommentsAcknowledged",
  GetTaskHasComments = "GetTaskHasComments",
  GetProductColors = "GetProductColors",
  GetSupplierCustomProductOptions = "GetSupplierCustomProductOptions",
  GetCustomProductOptionItems = "GetCustomProductOptionItems",
  GetCustomProductOptionConfigs = "GetCustomProductOptionConfigs",
  GetProductFiles = "GetProductFiles",
  GetSingleImagePerProduct = "GetSingleImagePerProduct",
  GetDiscountCodes = "GetDiscountCodes",
  GetSsoConnection = "GetSsoConnection",
  GetMyVerifiedDomains = "GetMyVerifiedDomains",
  GetVerifiedDomainsByAdmin = "GetVerifiedDomainsByAdmin",
  CheckVerifiedDomains = "CheckVerifiedDomains",
  GetShowTasksApiV2 = "GetShowTasksApiV2",
  GetTaskByIdApiV2 = "GetTaskByIdApiV2",
  GetCompanyTaskTagsApiV2 = "GetCompanyTaskTagsApiV2",
  GetTasksByStandApiV2 = "GetTasksByStandApiV2",
  GetTasksTagsInUseApiV2 = "GetTasksTagsInUseApiV2",
  GetTaskInstanceDrawerStateApiV2 = "GetTaskInstanceDrawerStateApiV2",
  GetTaskReviewInboxApiV2 = "GetTaskReviewInboxApiV2",
  GetTaskReviewInboxCountApiV2 = "GetTaskReviewInboxCountApiV2",
  GetTaskReviewInboxFacetsApiV2 = "GetTaskReviewInboxFacetsApiV2",
  GetTaskConditionalSummaryApiV2 = "GetTaskConditionalSummaryApiV2",
  GetTaskConditionalParentsApiV2 = "GetTaskConditionalParentsApiV2",
  GetTaskConditionalChildrenApiV2 = "GetTaskConditionalChildrenApiV2",
  GetTaskConditionalLocksApiV2 = "GetTaskConditionalLocksApiV2",
  GetTaskConditionalRemovalSubtreeApiV2 = "GetTaskConditionalRemovalSubtreeApiV2",
  GetTaskConditionalUnlinkSubtreeApiV2 = "GetTaskConditionalUnlinkSubtreeApiV2",
  GetStandCounters = "GetStandCounters",
  GetStandResponseFilesApiV2 = "GetStandResponseFilesApiV2",
  GetStandsPaginatedApiV2 = "GetStandsPaginatedApiV2",
  GetExhibitorCompaniesPaginatedApiV2 = "GetExhibitorCompaniesPaginatedApiV2",
  GetExhibitorPairsPaginatedApiV2 = "GetExhibitorPairsPaginatedApiV2",
  GetOrganiserStripeConnectAccounts = "GetOrganiserStripeConnectAccounts",
  GetSupplierStripeConnectAccount = "GetSupplierStripeConnectAccount",
  GetNotificationBarCount = "GetNotificationBarCount",
  GetPublicShowApiV2 = "GetPublicShowApiV2",
  GetLocalisedShowApiV2 = "GetLocalisedShowApiV2",
  GetLocalisedEmailTemplateApiV2 = "GetLocalisedEmailTemplateApiV2",
  GetOutstandingOrdersApiV2 = "GetOutstandingOrdersApiV2",
  GetPendingLanguagePurchasesApiV2 = "GetPendingLanguagePurchasesApiV2",
  GetPendingPaidFeaturePurchasesApiV2 = "GetPendingPaidFeaturePurchasesApiV2",
  GetImportableShowsByCompanyApiV2 = "GetImportableShowsByCompanyApiV2",
  GetOrganiserCompanyLanguagesApiV2 = "GetOrganiserCompanyLanguagesApiV2",
  GetPaidFeatureBoughtForProStorageApiV2 = "GetPaidFeatureBoughtForProStorageApiV2",
  GetPaidFeaturesBoughtByShowApiV2 = "GetPaidFeaturesBoughtByShowApiV2",
  GetAllPaidFeaturesApiV2 = "GetAllPaidFeaturesApiV2",
  GetSupplierByIdApiV2 = "GetSupplierByIdApiV2",
  GetCustomEmailTemplatesApiV2 = "GetCustomEmailTemplatesApiV2",
}
